import {
  COLLAPSED_SIDEBAR,
  RTL_LAYOUT,
  ADD_TO_CART,
  ADD_TO_CART_QUANTITY,
  ADD_TO_WISHLIST,
  SHOW_ALERT,
  HIDE_ALERT,
  REMOVE_FROM_CART,
  UPDATE_PRODUCT_QUANTITY,
  CHANGE_CURRENCY,
  SET_LANGUAGE,
  FINAL_PAYMENT,
  MOVE_WISHLISTITEM_TO_CART,
  REMOVE_FROM_WISHLIST,
  DELETE_USER,
  ADD_NEW_USER,
  DARK_MODE,
  INITIALIZE_CART,
  UPDATE_SHIPPING_COST,
  LOGIN,
  ORDER_CODE,
} from "./types";

import { CartAPI as API } from "../apis/CartAPI";

export const addProductItem = (data, alertMessage) => async (dispatch) => {
  let addProductData = {
    productID: data.objectID,
    quantity: data.minimumAmount,
    price: data.price,

    minimumAmount: data.minimumAmount,
    discountLabelFirstText: data.discountLabelFirstText,
    discountLabelSecondText: data.discountLabelSecondText,
    discountLabelThirdText: data.discountLabelThirdText,
    haveDiscount: data.haveDiscount,
    priceWithDiscount: data.priceWithDiscount,
  };

  var response = await API.addProduct(addProductData);

  if (response && response.status == 200) {
    var responseData = await response.data;

    data.id = responseData.shoppingCartID;
    data.subTotal = responseData.totalPrice;
    data.save = responseData.save;
    data.extraSave = responseData.extraSave;

    dispatch({
      type: ADD_TO_CART,
      payload: data,
    });
  }

  // const response = fetch('/api/ShoppingCart/AddProduct', {
  //     method: 'POST',
  //     body: JSON.stringify(addProductData),
  //     headers: {
  //         'Accept': 'application/json',
  //         'Content-Type': 'application/json'
  //     },
  // }).then(function (response) {
  //         return response.json();
  //     })
  //     .then(function (myJson) {

  //         data.id = myJson.shoppingCartID;
  //         data.subTotal = myJson.totalPrice;
  //         data.save = myJson.save
  //         data.extraSave = myJson.extraSave
  //         dispatch({
  //             type: ADD_TO_CART,
  //             payload: data
  //         })
  //     });
};

export const addProductItemQuantity =
  (data, alertMessage) => async (dispatch) => {
    console.log("action.js 1 addProductItemQuantity: ", data);

    let addProductData = {
      productID: data.objectID,
      quantity: data.quantity,
      price: data.price,

      minimumAmount: data.minimumAmount,
      discountLabelFirstText: data.discountLabelFirstText,
      discountLabelSecondText: data.discountLabelSecondText,
      haveDiscount: data.haveDiscount,
      priceWithDiscount: data.priceWithDiscount,
    };

    var response = await API.addProduct(addProductData);

    if (response && response.status == 200) {
      var responseData = await response.data;

      addProductData.id = responseData.shoppingCartID;
      data.totalPrice = responseData.totalPrice;

      dispatch({
        type: ADD_TO_CART_QUANTITY,
        payload: data,
      });
    }

    //   const response = fetch("/api/ShoppingCart/AddProduct", {
    //     method: "POST",
    //     body: JSON.stringify(addProductData),
    //     headers: {
    //       Accept: "application/json",
    //       "Content-Type": "application/json",
    //     },
    //   })
    //     .then(function (response) {
    //       return response.json();
    //     })
    //     .then(function (myJson) {
    //       console.log("action.js 2 addProductItemQuantity data response: ", myJson);

    //       data.id = myJson.shoppingCartID;
    //       data.totalPrice = myJson.totalPrice;
    //       dispatch({
    //         type: ADD_TO_CART_QUANTITY,
    //         payload: data,
    //       });
    //     });
  };

export const showAlert = (message, type) => ({
  type: SHOW_ALERT,
  payload: { message, type },
});

export const hideAlert = () => ({
  type: HIDE_ALERT,
});

export const addToWishlist = (data, alertMessage) => (dispatch) => {
  dispatch({
    type: ADD_TO_WISHLIST,
    payload: data,
  });
};

export const moveWishlistItemToCart = () => ({
  type: MOVE_WISHLISTITEM_TO_CART,
});

export const deleteItemFromWishlist = (data) => ({
  type: REMOVE_FROM_WISHLIST,
  payload: data,
});

export const removeProductItem = (data) => async (dispatch) => {
  var response = await API.removeProduct(data);

  if (response && response.status == 200) {
    dispatch({
      type: REMOVE_FROM_CART,
      payload: data,
    });
  }

  //   const response = fetch("/api/ShoppingCart/RemoveProduct", {
  //     method: "POST",
  //     body: JSON.stringify(data),
  //     headers: {
  //       Accept: "application/json",
  //       "Content-Type": "application/json",
  //     },
  //   });
};

export const updateProductQuantity = (data) => async (dispatch) => {
  let newData = data.cartItem;
  newData.quantity = data.newQuantity;

  var response = await API.updateProductQuantity(newData);

  if (response && response.status == 200) {
    var responseData = await response.data;

    data.subTotal = responseData.totalPrice;
    data.save = responseData.save;
    data.extraSave = responseData.extraSave;

    dispatch({
      type: UPDATE_PRODUCT_QUANTITY,
      payload: data,
    });
  }
};

export const changeCurrency = (currency) => ({
  type: CHANGE_CURRENCY,
  payload: currency,
});

export const setLanguage = (locale) => ({
  type: SET_LANGUAGE,
  payload: locale,
});

export const finalPayment = (history) => (dispatch) => {
  history.push("/final-receipt");
  dispatch({ type: FINAL_PAYMENT });
};

export const rtlLayoutAction = (isRtlLayout) => ({
  type: RTL_LAYOUT,
  payload: isRtlLayout,
});

//Redux Action To Emit Collapse Sidebar
export const collapsedSidebarAction = (isCollapsed) => ({
  type: COLLAPSED_SIDEBAR,
  isCollapsed,
});

//======== Admin-panel actions ========

//add user
export const addNewUser = (data) => ({
  type: ADD_NEW_USER,
  payload: data,
});

//delete user
export const deleteUser = (data) => ({
  type: DELETE_USER,
  payload: data,
});

//======== Customiser ========
/**
 * Redux Action To Emit Dark Mode
 * @param {*boolean} isDarkMode
 */
export const darkModeAction = (isDarkMode) => ({
  type: DARK_MODE,
  payload: isDarkMode,
});

export const initializeCart = (data) => ({
  type: INITIALIZE_CART,
  payload: data,
});

export const updateShippingCost = (data) => ({
  type: UPDATE_SHIPPING_COST,
  payload: data,
});

export const setOrderCode = (data) => ({
  type: ORDER_CODE,
  payload: data,
});
